import axios from 'axios';

/**
 * 获取后端 API Base URL。
 * 约定：返回值必须以 `/api/v1` 结尾，确保各服务只需要维护资源路径（如 `/orders`）。
 */
const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    const raw = String(process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');
    if (!raw) return 'http://localhost:8081/api/v1';
    return raw.endsWith('/api/v1') ? raw : `${raw}/api/v1`;
  }

  if (process.env.REACT_APP_ENV === 'pre') {
    return 'https://api-test.caligula.darkstring.com/api/v1';
  }
  
  if (process.env.NODE_ENV === 'production') {
    return 'https://api-prod.caligula.darkstring.com/api/v1';
  }
  
  return 'http://localhost:8081/api/v1';
};

const createApiClient = () => {
  const api = axios.create({
    baseURL: getApiUrl(),
    timeout: 30000,
  });

  api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      
      // 提取后端返回的错误信息
      const backendMessage = error.response?.data?.error || error.response?.data?.message;
      if (backendMessage) {
        error.message = backendMessage;
      }
      
      return Promise.reject(error);
    }
  );

  return api;
};

export default createApiClient();
